import React, { ComponentType, PureComponent } from 'react';
import { LicenseNoteContext } from 'services/LicenseNoteContext';

const withLicenseNoteContext = <P extends object>(Component: ComponentType<P>) => {
  class WithLicenseNoteContext extends PureComponent<P> {
    render() {
      return (
        <LicenseNoteContext.Consumer>{value => <Component {...this.props} {...value} />}</LicenseNoteContext.Consumer>
      );
    }
  }

  return WithLicenseNoteContext;
};

export default withLicenseNoteContext;
